var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnippetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m943.12 943.12v-256.12c0-23.902 14.066-40.234 31.5-35.625 14.512 3.8359 34.621 42.094 86.625 39s78.75-52.129 78.75-90.375-26.746-87.281-78.75-90.375-72.113 35.164-86.625 39c-17.434 4.6094-31.5-12.098-31.5-36v-255.75h-256.12c-23.902 0-40.234-14.066-35.625-31.5 3.8359-14.512 42.094-34.621 39-86.625s-52.129-78.75-90.375-78.75-87.281 26.746-90.375 78.75 35.164 72.113 39 86.625c4.6094 17.434-12.098 31.5-36 31.5h-255.75v256.12c0 23.902 14.066 40.234 31.5 35.625 14.512-3.8359 34.621-42.094 86.625-39s78.75 52.129 78.75 90.375-26.746 87.281-78.75 90.375-72.113-35.164-86.625-39c-17.434-4.6094-31.5 12.098-31.5 36v255.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnippetIcon);
export default __webpack_public_path__ + "static/media/snippet-icon.99aeafa1ea7e50013e870454c950d83e.svg";
export { ForwardRef as ReactComponent };